// #

import { TUploadedSalesReportsRow } from 'redux/reducers/settings/types';
import { DATES, DATES_ID } from 'services/constants/dates';
import { EIconButtons } from 'services/constants/iconsTypes';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';

// {
// 	"id": 2,
// 	"emId": 329,
// 	"fileName": null,
// 	"comments": "New Comment",
// 	"uploadedAt": "2025-04-10T13:25:10.451699Z",
// 	"uploadedBy": "9cadc8f5-a254-4997-95eb-7d0ef792da64",
// 	"fileStatus": {
// 			"id": 2,
// 			"name": "No Sales",
// 			"description": null
// 	},
// 	"noSales": true,
// 	"processedOrders": null,
// 	"easComments": null,
// 	"processedAt": null
// },
export const tableStructure: TTableStructure<keyof TUploadedSalesReportsRow>[] = [
	{
		name: 'EAS Order Id',
		selector: 'id' as keyof TUploadedSalesReportsRow,
		show: false,
		sortable: true,
		filterable: false,
		filter: [['text', 'text']],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'File name',
		selector: 'fileName' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: false,
		filter: [['text', 'text']],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comments',
		selector: 'comments' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Uploaded at',
		selector: 'uploadedAt' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Uploaded by',
		selector: 'uploadByName' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Number of processed orders',
		selector: 'processedOrders' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EAS comments',
		selector: 'easComments' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Processed at',
		selector: 'processedAt' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Status',
		selector: 'fileStatus' as keyof TUploadedSalesReportsRow,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['Pending', 'Pending'],
			['New', 'New'],
			['No Sales', 'No Sales'],
			['Processing', 'Processing'],
			['Failed', 'Failed'],
			['Processed', 'Processed'],
		],
		colors: [
			['New', 'primary.light'],
			['No Sales', 'warning.light'],
			['Failed', 'error.light'],
			['Processed', 'success.light'],
			['Pending', 'secondary.light'],
			['Processing', 'info.light'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions' as keyof TUploadedSalesReportsRow,
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Download File', icon: EIconButtons.DOWNLOAD }],
		buttonFilter: (item: TUploadedSalesReportsRow) => {
			switch (item.fileName !== null) {
				case true:
					return [{ name: 'Download File', icon: EIconButtons.CLOUD_DOWNLOAD }];
				default:
					return [];
			}
		},
	},
];
